import React from 'react'
import { Route } from 'react-router-dom'
import context from '../context'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { PageForbidden403 } from '@/components/403'

export default ({ render, component: Component, layout: Layout = context.defaultLayout, permission, componentProps, ...rest }) => {
  const isGranted = usePermissionChecker()
  if (!isGranted(permission)) return <Layout><PageForbidden403 /></Layout>
  return (
    <Route {...rest} render={props => (
      <Layout>
        {typeof render === 'function' ? render(props) : <Component {...componentProps} {...props} />}
      </Layout>
    )} />
  )
}



// WEBPACK FOOTER //
// ./src/utils/Route.js